import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BalancoComponent } from './balanco.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: BalancoComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BalancoRoutingModule { }
